import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/agen/view.tsx");
